import React from 'react'

const Footer = () => {
	return (
		<div className="Section -footer">
			<div className="Section__content">
				I'm available for work, get in touch
				<br />maxim.pokrovskii@gmail.com
			</div>
		</div>
	)
}

export default Footer



// WEBPACK FOOTER //
// ./src/footer.js